<template>
    <input type="text" ref="datepicker" value="">
</template>
<script>
import $ from 'jquery'
import 'jquery-ui/ui/widgets/datepicker'
import 'jquery-ui/themes/base/all.css'

export default {
  name: 'DatePicker',
  props: {
    value: String,
    initDate: '',
    options: {
      dateFormat: 'yy-mm-dd',
      changeMonth: true,
      changeYear: true
    }
  },
  data () {
    return {
      selectedDate: '',
      timeHandler: null
    }
  },
  mounted () {
    const self = this
    const dtpicker = $(self.$refs.datepicker)
    var stertYear = "1920"//開始年固定
    var today = new Date()//本日日付取得
    var endYear = new Date(today.getFullYear()) - 20
    self.options.showMonthAfterYear = true,//年月を順列に変更
    self.options.changeMonth = true,//月選択をプルダウン化        
    self.options.changeYear = true,//年選択をプルダウン化
    self.options.yearRange = stertYear+":"+endYear, //年 選択範囲
    self.options.maxDate = new Date(endYear, today.getMonth(), today.getDate()),//本日から−20年の同日まで選択可能
    self.options.dateFormat = 'yy-mm-dd',//ハイフンで日付を表示
    self.options.monthNamesShort = ['1','2','3','4','5','6','7','8','9','10','11','12'],//月を数で表示
    self.options.dayNamesMin = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],//曜日を変更
    dtpicker.datepicker(self.options).on('change', () => {
      // ここに日付変更したときの処理を書く
      self.selectedDate = dtpicker.val()
      self.$emit('input', dtpicker.val())
    })
    $('#ui-datepicker-div').addClass('notranslate')
    if (self.initDate !== '') {
      dtpicker.datepicker('setDate', self.initDate)
    }

    this.timeHandler = setTimeout(this.dateModified, 1000)
  },
  beforeDestroy () {
    if (this.timeHandler !== null) {
      window.clearTimeout(this.timeHandler)
    }
  },
  methods: {
    dateModified () {
      const dtpicker = $(this.$refs.datepicker)
      if (this.selectedDate !== this.value) {
        this.selectedDate = this.value
        dtpicker.datepicker('setDate', this.value)
      }

      this.timeHandler = setTimeout(this.dateModified, 1000)
    }
  }
}
</script>

<style>
    .ui-state-hover, .ui-widget-content .ui-state-hover {
        border: 1px solid #003eff/*{borderColorActive}*/;
        background: #007fff/*{bgColorActive}*/ /*{bgImgUrlActive}*/ /*{bgActiveXPos}*/ /*{bgActiveYPos}*/ /*{bgActiveRepeat}*/;
        font-weight: normal/*{fwDefault}*/;
        color: #ffffff/*{fcActive}*/;
    }
</style>